import React from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import appCss from './App.module.css'
import { Helmet } from 'react-helmet'
import { ManagersProvider } from './ManagersContext'
// TODO simplify with deconstructive assignment (from an index.js?)
import PageHome from '../components/home/pageHome'
import PageCode from '../components/code/pageCode'
import PageResume from '../components/resume/pageResume'
import PageMusic from '../components/music/pageMusic'
import PagePortfolio from '../components/portfolio/pagePortfolio'
import PageTech from '../components/tech'
import PageBlog from '../components/blog'
import PagePublications from '../components/publications'
import PageDissertation from '../components/dissertation'
import PageThesis from '../components/thesis'
import PageTalks from '../components/talks'
import NotFound404 from '../components/notFound404'

function App () {
  const renavigates = [
    { from: '/technologies/javascript.php', to: '/tech/javascript' },
    { from: '/technologies/list.php', to: '/tech/list' },
    { from: '/technologies/react.php', to: '/tech/react' },
    { from: '/technologies/node.php', to: '/tech/node' },
    { from: '/technologies/redux.php', to: '/tech/redux' },
    { from: '/technologies/webpack.php', to: '/tech/webpack' },
    { from: '/technologies/css.php', to: '/tech/css' },
    { from: '/technologies/html.php', to: '/tech/html' },
    { from: '/technologies/angular.php', to: '/tech/angular' },
    { from: '/technologies/responsiveDesign.php', to: '/tech/responsive-design' },
    { from: '/technologies/javascriptHoisting.php', to: '/tech/javascript-hoisting' },
    { from: '/technologies/browserCompatability.php', to: '/tech/list' },
    { from: '/technologies/sql.php', to: '/tech/sql' },
    { from: '/home/pageHome.php', to: '/home' },
    { from: '/code/pageCode.php', to: '/code' },
    { from: '/music/pageMusic.php', to: '/music' },
    { from: '/resume/pageResume.php', to: '/resume' },
    { from: '/blog/pageBlogs.php', to: '/blog' },
    { from: '/portfolio/pages/pagePublications.php', to: '/publications' },
    { from: '/portfolio/pageDissertation.php', to: '/dissertation' },
    { from: '/portfolio/pageThesis.php', to: '/thesis' },
    { from: '/talks/pageTalks.php', to: '/talks' },
    { from: '/portfolio/pages/pageClient_crocs.php', to: '/portfolio/crocs/splash' },
    { from: '/portfolio/pages/pageClient_tenx.php', to: '/portfolio/tenx/splash' },
    { from: '/portfolio/pages/pageClient_sears.php', to: '/portfolio/sears/splash' },
    { from: '/portfolio/pages/pageClient_path.php', to: '/portfolio/pathfinder/splash' },
    { from: '/portfolio/pages/pageClient_tr.php', to: '/portfolio/truven/splash' },
    { from: '/portfolio/pages/pageClient_ubs.php', to: '/portfolio/ubs/splash' },
    { from: '/portfolio/pages/pageClient_usaf.php', to: '/portfolio/usaf/splash' },
    { from: '/portfolio/pages/pageClient_abnAmro.php', to: '/portfolio/abnamro/splash' },
    { from: '/portfolio/pages/pageClient_ies.php', to: '/portfolio/ies/splash' },
    { from: '/portfolio/pages/pageClient_xb.php', to: '/portfolio/xb/splash' },
    { from: '/portfolio/pages/pageClient_maytag.php', to: '/portfolio/maytag/splash' },
    { from: '/portfolio/pages/pageClient_watts.php', to: '/portfolio/watts/splash' },
    { from: '/portfolio/pages/pageClient_billwhitney.php', to: '/portfolio/billwhitney/splash' },
    { from: '/portfolio/pages/pageClient_spectrum.php', to: '/portfolio/spectrum/splash' },
    { from: '/j/index', to: '/home' },
    { from: '/j/pageEmployerList', to: '/portfolio' },
    { from: '/j/pageSkillsList', to: '/tech/list' },
    { from: '/j/pageResume', to: '/resume' },
    { from: '/j/pageLinks', to: '/home' },
    { from: '/j/pageContact', to: '/home' },
    { from: '/j/pageEmployers', to: '/portfolio' },
    { from: '/j/pageSkills', to: '/tech/list' },
    { from: '/j/pageBlogList', to: '/blog' },
    { from: '/j/pageCode', to: '/code' },
    { from: '/j/pageTalks', to: '/talks' },
    { from: '/j/pageSharc', to: '/static/1996-08-11_sharc_ICMPC.pdf' },
    { from: '/j/pagePublications', to: '/publications' },
    { from: '/d/', to: '/home' },
    { from: 'j/pageBlog', to: '/blog' },
    { from: 'j/popupSharcInfo', to: '/static/1996-08-11_sharc_ICMPC.pdf' },
    { from: '/tech', to: '/tech/list' },
  ]

  return (
    <Router>
      <div className={appCss.App}>
        <Helmet>
          <title>Greg Sandell - Home</title>
          <meta name='description' content="Software Developer Greg Sandell's web page" />
          <meta name='theme-color' content='#d4c792' />
        </Helmet>
        <ManagersProvider>
          <Routes>
            <Route path='*' element={<NotFound404 />} />
            <Route path='/' element={<PageHome />} />
            <Route path='/home' element={<PageHome />} />
            <Route path='/code' element={<PageCode />} />
            <Route path='/resume' element={<PageResume />} />
            <Route path='/music' element={<PageMusic />} />
            <Route path='/portfolio/:client/:type' element={<PagePortfolio />} />
            <Route path='/tech/:topic' element={<PageTech />} />
            <Route path='/blog' element={<PageBlog />} />
            <Route path='/publications' element={<PagePublications />} />
            <Route path='/dissertation' element={<PageDissertation />} />
            <Route path='/thesis' element={<PageThesis />} />
            <Route path='/talks' element={<PageTalks />} />
            {renavigates.map((nav, i) => (
              <Route key={`renav_${i}`} path={nav.from} element={<Navigate to={nav.to} />} />
            ))}
          </Routes>
        </ManagersProvider>
      </div>

    </Router>
  )
}

export default App
